import { Entity } from '../../modules/dto'
import { DtoWrapper, LoadingState } from './dto.state'
import { cloneDeep, isEqual } from 'lodash'

/** Utils for working with entities and entity-wrappers (entity-store) */
export default class DtoStoreUtils {
  /** generates store id for entity with type and id. */
  static getStoreIdFromTypeAndId(dtoType: string, id: number): string {
    return `${dtoType}_${id}`
  }

  /** generates store id from entity-type and -id. */
  static getStoreIdFromEntity(entity: Entity): string {
    return DtoStoreUtils.getStoreIdFromTypeAndId(entity.type, entity.fields['id'])
  }

  /** takes fields object and wraps it into an entity object. */
  static convertFieldsToEntity(fields: object, type: string): Entity {
    const result = new Entity()
    result.fields = fields
    result.type = type
    return result
  }

  /** takes an entity object and wraps it in a container for ngrx-store usage. */
  static packEntity(entity: Entity, options?: { isPartial?: boolean }): DtoWrapper {
    const isPartial = !!options?.isPartial
    const wrapper = new DtoWrapper()
    // make a deep copy of the entity
    const clone = cloneDeep(entity)
    wrapper.dto = <Entity>clone
    wrapper.dtoKey = DtoStoreUtils.getStoreIdFromTypeAndId(entity.type, entity.fields['id'])
    if (isPartial) {
      wrapper.loadingState = LoadingState.Partial
    }
    return wrapper
  }

  /** unwraps an entity from a dto-wrapper */
  static unpackEntity(entityWrapper: DtoWrapper): Entity {
    return <Entity>cloneDeep(entityWrapper.dto)
  }
}
